import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Grid,
  Typography,
  IconButton,
  useTheme,
  Tooltip,
  Container,
  Modal,
  LinearProgress,
} from '@mui/material';
import {
  Add as AddIcon,
  Folder as FolderIcon,
  Share as ShareIcon,
  Link as LinkIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import * as QRCode from 'qrcode';
import { toast } from 'react-toastify';
import { rwsign } from '../../assets';

const Dashboard: React.FC<{ folders: any }> = ({ folders }) => {
  const theme = useTheme();
  const navigate = useNavigate();


  const [drawerOpen, setDrawerOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [qrImage, setQrImage] = useState<string>('');
  const [folderUrl, setFolderUrl] = useState<string>('');


  useEffect(() => {
    if (folders) {
      const fetchedFolders = folders?.map((folder: any) => ({
        id: folder._id,
        name: folder.name,
        count: folder.count,
      }));
      setFolderUrl(`https://portfolio.rajivwilliams.com/folders`);
    }
  }, [folders]);

  const handleCreateFolder = () => {
    setDrawerOpen(true);
  };

  const handleShare = async () => {
    if (folderUrl) {
      try {
        QRCode.toDataURL(folderUrl, { width: 200, height: 200 }, (err, url) => {
          if (err) {
            console.error('Error generating QR code:', err);
            return;
          }
          setQrImage(url);
          setModalOpen(true);
        });
        setModalOpen(true);
      } catch (err) {
        console.error('Error generating QR code:', err);
      }
    }
  };

  const handleCopyLink = (folderId: string) => () => {
    if (folderUrl) {
      navigator.clipboard.writeText(`https://portfolio.rajivwilliams.com/folders/${folderId}`).then(() => {
        toast.success('Folder link copied to clipboard');
      });
    }
  };

  const handleDownloadQR = () => {
    if (qrImage) {
      const a = document.createElement('a');
      a.href = qrImage;
      a.download = 'FolderQRCode.png';
      a.click();
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };



  return (
    <Container maxWidth="xl">
      <Box sx={{ p: 2, minHeight: '100vh' }}>
        {/* Header Section */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3} sx={{ mx: 1 }}>
          <Typography variant="h4" color="primary" sx={{ fontWeight: '600', color: 'black' }}>
            All Files
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Tooltip title="Share All Folders">
              <IconButton
                aria-label="Share"
                size="small"
                onClick={handleShare}
                sx={{ mr: 1, p: 1, color: 'black' }}
              >
                <ShareIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Copy Link">
              <IconButton aria-label="Copy Link" size="small" sx={{ p: 1, color: 'black' }} onClick={handleCopyLink('')}>
                <LinkIcon fontSize="small" />
              </IconButton>
            </Tooltip>

          </Box>
        </Box>

        {/* Folder Grid */}
        <Grid container spacing={3}>
          {folders.map((folder: { files: any; _id: string; name: string; }) => (
            <Grid item xs={12} sm={6} md={3} key={folder._id}>
              {/* <Box
                sx={{
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  p: 3,
                  border: `2px solid ${theme.palette.divider}`,
                  borderRadius: 4,
                  boxShadow: theme.palette.mode === 'dark' ? 4 : 2,
                  backgroundColor: "#0b283e",
                  width: '100%',
                  height: 200,
                  ':hover': {
                    boxShadow: 6,
                    backgroundColor: "#000",
                  },
                  overflow: 'hidden',
                  '&:hover .hover-icons': {
                    opacity: 1,
                  },
                }}
                onDoubleClick={() => {
                  navigate(`/folders/${folder._id}`);
                }}
                onClick={() => {
                  navigate(`/folders/${folder._id}`);
                }}
              > */}
              <Box
                sx={{
                  position: "relative",
                  borderRadius: "24px",
                  overflow: "hidden",
                  height: 220,
                  cursor: "pointer",
                  background: "linear-gradient(135deg, #0f63a5 0%, #0b283e 100%)",
                  boxShadow: "0 8px 25px rgba(15,99,165,0.25)",
                  transition: "all 0.4s ease",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",

                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 20px 40px rgba(15,99,165,0.45)",
                  },

                  "&:hover .hover-icons": {
                    opacity: 1,
                    transform: "translateY(0)",
                  },
                }}
                onClick={() => navigate(`/folders/${folder._id}`)}
              >

                {/* Hover Icons */}
                {/* <Box
                  className="hover-icons"
                  sx={{
                    position: 'absolute',
                    top: 10,
                    right: 10,
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 1,
                    opacity: 0,
                    transition: 'opacity 0.3s',
                  }}
                >
                  <Tooltip title="Share Folder">
                    <IconButton aria-label="Share" size="small"
                      onClick={(e) => {
                        e.stopPropagation();   // 🔥 Important
                        handleShare();
                      }}
                      sx={{ mr: 1, p: 1 }}>
                      <ShareIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Copy Link">
                    <IconButton
                      aria-label="Copy Link"
                      size="small"
                      sx={{ p: 1 }}
                      // onClick={handleCopyLink(folder._id)}
                      onClick={(e) => {
                        e.stopPropagation();   // 🔥 Important
                        handleCopyLink(folder._id)();
                      }}
                    >
                      <LinkIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box> */}
                <Box
                  className="hover-icons"
                  sx={{
                    position: "absolute",
                    top: 15,
                    right: 15,
                    display: "flex",
                    gap: 1,
                    opacity: 0,
                    transform: "translateY(-5px)",
                    transition: "all 0.3s ease",
                  }}
                >
                  <Tooltip title="Share Folder">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleShare();
                      }}
                      sx={{
                        backgroundColor: "rgba(255,255,255,0.2)",
                        backdropFilter: "blur(10px)",
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: "#ffffff",
                          color: "#0f63a5",
                        },
                      }}
                    >
                      <ShareIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Copy Link">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCopyLink(folder._id)();
                      }}
                      sx={{
                        backgroundColor: "rgba(255,255,255,0.2)",
                        backdropFilter: "blur(10px)",
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: "#ffffff",
                          color: "#0f63a5",
                        },
                      }}
                    >
                      <LinkIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>

                <FolderIcon sx={{ fontSize: 100, color: "#fff", mb: 2 }} />
                <img src={rwsign} alt="DS Logo" style={{ width: '40%', height: 'auto', marginBottom: '1px', userSelect: 'none', }} />
              </Box>

              {/* Folder Name and Count */}
              <Box
                sx={{
                  m: 1,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  color: '#0f63a5'
                }}
                onDoubleClick={() => {
                  navigate(`/folders/${folder._id}`);
                }}
              >
                <FolderIcon fontSize="large" />
                <Box sx={{ ml: 1 }}>
                  <Typography variant="body1" noWrap sx={{ fontWeight: '600', color: 'black' }}>
                    {folder.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    noWrap
                    sx={{ fontWeight: '400', opacity: 0.7, color: 'black' }}
                  >
                    Total Items : {folder.files.length}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Modal */}
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '80%', md: 400 },
            bgcolor: '#adadad',
            boxShadow: 24,
            borderRadius: 2,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Modal Header */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              px: 2,
              py: 1,
              bgcolor: '#0f63a5',
              color: 'white',
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: '500' }}>
              QR Code
            </Typography>
            <IconButton onClick={handleCloseModal} sx={{ color: 'white' }}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Modal Content */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              px: 3,
              py: 4,
            }}
          >
            {qrImage ? (
              <img
                src={qrImage}
                alt="QR Code"
                style={{
                  maxWidth: '100%',
                  maxHeight: '200px',
                  marginBottom: '16px',
                  userSelect: 'none',
                }}
              />
            ) : (
              <Typography variant="body1" color="textSecondary">
                Generating QR code...
              </Typography>
            )}

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: 2,
                width: '100%',
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleDownloadQR}
                sx={{
                  flexGrow: 1,
                  maxWidth: { xs: '100%', sm: '48%' },
                }}
              >
                Download QR
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleCloseModal}
                sx={{
                  flexGrow: 1,
                  maxWidth: { xs: '100%', sm: '48%' },
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

    </Container>
  );
};

export default Dashboard;

